import { FormLabel } from '@/components/ui/form';
import { useDatePicker } from '../../shared/hooks/useDatePicker';
import DatePickerField from '@/domain/termine/components/DatePicker/DatePickerField';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import dayjs, { Dayjs } from 'dayjs';

interface DatePickerSheetProps {
  value: Dayjs | undefined;
  onChange: (value: Dayjs | undefined) => void;
  label: string;
}

export function DatePickerSheet({
  value,
  onChange,
  label,
}: DatePickerSheetProps) {
  const { handleDateSelect } = useDatePicker({ value, onChange });

  const handleSelect = (date: Date) => {
    handleDateSelect(date);
    onChange(dayjs(date));
  };

  return (
    <>
      <FormLabel>{label}</FormLabel>
      <DatePickerField
        date={value}
        onSelect={handleSelect}
        onChange={() => {}}
        icon={faCalendar}
      />
    </>
  );
}
